import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import { Colophon } from "../../types/colophon";

import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";
import {
  EntityWithMetadataTableSuffixColumns,
  createEntityFilterSpec,
  publishedIdColumn,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";

import { formatEvidenceName, VersionCell } from "./EntityUtils";

const columnHelper = createMRTColumnHelper<Colophon>();

const colophonColumns: MRT_ColumnDef<Colophon, any>[] = [
  publishedIdColumn,
  columnHelper.accessor("work", {
    header: "Work",
    enableColumnFilter: false,
    Cell: ({ cell }) => <EntityReferenceComponent entity={cell.getValue()} />,
  }),
  columnHelper.accessor("colophon", {
    header: "Colophon",
  }),
  columnHelper.accessor("author", {
    header: "Author of Colophon",
    enableColumnFilter: false,
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <EntityReferenceComponent entity={cell.getValue()} />
      ) : (
        "-"
      ),
  }),
  columnHelper.accessor("name_internal_evidence", {
    header: "Name Internal Evidence",
    Cell: ({ cell }) =>
      cell.getValue() ? formatEvidenceName(cell.getValue()) : "-",
  }),
  columnHelper.accessor("version", {
    header: "Version",
    enableColumnFilter: false,
    Cell: ({ cell }) => <VersionCell value={cell.getValue()} />,
  }),
  ...EntityWithMetadataTableSuffixColumns,
];

export const colophonFilterSpec: FilterSpec = createEntityFilterSpec({
  colophon: { kind: "string" },
  name_internal_evidence: { kind: "string" },
});

export default colophonColumns;
